module.exports = __webpack_public_path__ + "static/media/baanbe_studio.21ace6b5.jpg";